import React from "react";
import DashboardSmallCard from "./DashboardSmallCard";

const ApplicationCount = ({ applicationCount }) => {
  return (
    <div className="grid grid-cols-4 gap-4">
      {applicationCount?.map((v, i) => {
        return (
          <DashboardSmallCard
            key={i}
            title={v?.job_title}
            para={v?.total_applications}
            buttonStatus={false}
          />
        );
      })}
    </div>
  );
};

export default ApplicationCount;
